import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { Section } from './itemView/ItemView'
import gql from 'graphql-tag'
import {useQuery} from '@apollo/react-hooks'
import { get, isEmpty } from 'lodash'

// query allItemLinks($itemId: ID!, $max: Int, $offset: Int) {

const GET_ITEM_LINKS = gql`
 query itemLinksByItemId($itemId: ID!) {
    allItemLinks(itemId: $itemId) {
      itemLinks{
        itemId
        title
        relatedItemId
        relatedItemTitle
        type
        typeLabel
        typeReverseDescription
        rel
      }
    }
  }
`

export default function AssociatedItems() {
  const { id } = useParams()
  const itemId = id

  const { loading, error, data } = useQuery(GET_ITEM_LINKS, {
    variables: {
      itemId: id
    },
    fetchPolicy: 'cache-and-network'
  })

  const itemLinks = get(data, 'allItemLinks.itemLinks', {})
  // console.log(data)

  return (
    <div className={(loading ? 'sb-item-border-loading' : 'sb-item-border')}>
      <div className={error ? 'alert alert-danger' : 'd-none'} role='alert'>
        An error occurred while loading associated items for item with ID={id}.
      </div>
      <div>
        {renderItemLinks(itemLinks)}
      </div>
    </div>
  )

  function renderItemLinks(itemLinks){
    if (isEmpty(itemLinks)) return null
    let itemLinkItems = []
    itemLinks.forEach((itemLink, i) => {
      // outbound/forward links
      if (itemLink.itemId === itemId) {
        let itemLinkTitle = itemLink.annotation || itemLink.relatedItemTitle || itemLink.typeLabel || 'Related Item'
        let linkText = itemLink.relatedItemTitle || 'Related Item'
        itemLinkItems.push(
          <li key={i}>
            <em>{itemLink.typeLabel}</em>&nbsp;
            <Link to={`/item/${itemLink.relatedItemId}`} title={itemLinkTitle}>{linkText}</Link>
          </li>
        )
      }
      // inbound/reverse links
      else {
        let itemLinkTitle = itemLink.annotation || itemLink.title || itemLink.typeReverseDescription || 'Related Item'
        let linkText = itemLink.title || 'Related Item'
        itemLinkItems.push(
          <li key={i}>
            <em>{itemLink.typeReverseDescription}</em>&nbsp;
            <Link to={`/item/${itemLink.itemId}`} title={itemLinkTitle}>{linkText}</Link>
          </li>
        )
      }
    })

    if (!(itemLinkItems && itemLinkItems.length)) return null

    return (
      <Section id="associated-items" title="Associated Items">
        <ul>
          {itemLinkItems}
        </ul>
      </Section>
    )
  }
}

